module.exports = __webpack_public_path__ + "media/images/icons/home-fd5c5e77224a02910e3c3b79d77e8aac.svg";